export const postText = async (receiptId, phoneNumber) => {
  const inFlowApiUrl = import.meta.env.VITE_IN_FLOW_API_URL;
  const token = window.sessionStorage.getItem("session_token");
  const headers = { Authorization: `Bearer ${token}` };
  const phone = phoneNumber.replace(/[^\d.-]/g, "");

  const res = await fetch(`${inFlowApiUrl}/text`, {
    method: "POST",
    body: JSON.stringify({ receiptID: receiptId, phone }),
    headers,
  });
  if (!res.ok) throw new Error(res.status);
  return await res.json();
};
